import { Header } from "../components/landing/Header";
import { Seo } from "../components/Seo";
import { Hero } from "../components/landing/Hero";
import { StatsBand } from "../components/landing/StatsBand";
import { ConnectivityServices } from "../components/landing/ConnectivityServices";
import { Solutions } from "../components/landing/Solutions";
import { HowWeWork } from "../components/landing/HowWeWork";
import { Suppliers } from "../components/landing/Suppliers";
import { WhyUs } from "../components/landing/WhyUs";
import { Resources } from "../components/landing/Resources";
import { Faq } from "../components/landing/Faq";
import { FinalCTA } from "../components/landing/FinalCTA";
import { Footer } from "../components/landing/Footer";

export default function Landing() {
  return (
    <div className="bg-[#05071F] text-white min-h-screen font-body">
      <Seo
        title="Silent Sentry, LLC — Enterprise Technology Advisory | Omaha, NE"
        description="Vendor-neutral technology brokerage with defense-first engineering. Cybersecurity, cloud, AI, networking, UCaaS, CCaaS & IoT from 400+ top suppliers — at no cost to you."
      />
      <Header />
      <main>
        <Hero />
        <StatsBand />
        <ConnectivityServices />
        <Solutions />
        <HowWeWork />
        <Suppliers />
        <WhyUs />
        <Resources />
        <Faq />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
